<template>
  <div class="section center-vertical">
    <div class="section-horizontal mt-5 mb-5 nucleo11scroll1">
      <div class="horizontal-content">
        <div class="horizontal horizontal-1">
          <div class="titulo">///</div>
          <div class="text mt-5">
            Linha do tempo das ações do governo federal no âmbito do fomento à
            pesquisa para a descoberta da vacina, com o início da emergência
            sanitária no mundo em razão da pandemia do Coronavírus, de 11 de
            março de 2020 até 27 de abril de 2021.
          </div>
          <a
            class="link-fonte"
            href="https://observadhecovid.org.br/pesquisas/balanco-da-politica-brasileira-de-vacinas/#Linha_do_Tempo_da_Imunizacao_na_pandemia_da_Covid-19"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        <div class="seta">
          <i class="bi bi-chevron-double-right"></i>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">11/Março/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            A OMS declara a pandemia mundial. O Brasil bate recordes de
            desemprego e o governo Bolsonaro corta as verbas destinadas aos
            programas sociais responsáveis por amortizar as desigualdades, como
            o Bolsa Família e o Minha Casa Minha Vida.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">12/Março/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Primeira morte causada pela Covid-19 no Brasil.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">20/Março/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            É declarado, em todo o território nacional, o estado de transmissão
            comunitária do novo coronavírus (Covid-19).
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">16/Abril/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Bolsonaro demite Luiz Henrique Mandetta por divergências em relação
            a contenção da disseminação do vírus. Enquanto o Ministro da Saúde
            defende o uso de máscaras e o isolamento social, o presidente se
            opunha ao isolamento, ao uso de equipamentos de segurança e optava
            pela divulgação da hidroxicloroquina como medicamento preventivo da
            forma grave da doença, mesmo sem comprovação científica.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">15/Maio/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Menos de um mês depois de tomar posse, Nelson Teich deixa o
            Ministério da Saúde após divergência com Bolsonaro. O presidente
            insistia na compra de hidroxicloroquina e na desmobilização do
            isolamento social.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">16/Maio/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Eduardo Pazuello, general do exército, assume interinamente o
            Ministério da Saúde. Ele e Bolsonaro apoiavam o uso de medicamentos
            sem comprovação científica em detrimento das medidas de isolamento
            social e do investimento em vacinas.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">14/Agosto/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Bolsonaro ignora contato para negociação de imunizantes com a
            farmacêutica Pfizer, que ofereceu a produção de 500 mil doses da
            vacina até dezembro de 2020 e 70 milhões até junho de 2021.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">18/Agosto/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Pfizer aumenta a proposta de produção de vacinas e oferece 1,5
            milhões de doses até dezembro, mais 1,5 milhões de doses até
            fevereiro de 2021 e 70 milhões de doses até junho. Bolsonaro recusa
            novamente.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">21/Outubro/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Bolsonaro impede a negociação para a compra de 46 milhões de doses
            da CoronaVac e diz que não compraria a vacina, mesmo que fosse
            aprovada pela Anvisa. O governo federal se retirou das negociações
            com o Sinovac, laboratório chinês responsável pela produção, que
            precisou ser feita pelo Instituto Butantan de maneira autônoma.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">11/Novembro/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Terceira proposta da Pfizer é recusada por Bolsonaro. O Brasil ainda
            não tem um imunizante e continua investindo em medicamentos
            comprovadamente ineficazes contra Covid-19 e que causam risco à
            saúde.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">25/Novembro/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Com 170 mil mortos, o Brasil é o segundo país com mais mortes por
            Coronavírus no mundo. Enquanto isso, apenas 4,6% do orçamento para
            contratação de profissionais da saúde foi utilizado.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">08/Dezembro/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            A primeira pessoa é vacinada no mundo. O imunizante utilizado foi
            fabricado pela Pfizer e aplicado na Inglaterra em uma idosa de 90
            anos.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">11/Dezembro/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Sem ter imunizado qualquer pessoa no Brasil, a estratégia anunciada
            por Pazuello consistiu em um plano de implementação do "kit covid",
            investindo mais de R$ 250 milhões na compra de medicamentos para
            verme e malária, sem qualquer comprovação científica, para fins de
            distribuição gratuita em farmácias populares. O valor permitiria
            comprar 13,18 milhões de vacinas de Oxford, imunizando 7 milhões de
            pessoas.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">16/Dezembro/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            É lançado o Plano Nacional de Imunização contra Covid-19, que não
            prevê cronograma e inclui apenas 2 vacinas entre as encomendas
            tecnológicas feitas pelo país - Fiocruz/Astrazeneca e Covax
            Facility. A entrada do Brasil no consórcio da Covax Facility foi
            dificultada pelo Ministro de Relações Exteriores, Ernesto Araújo. O
            país só passou a integrar o consórcio em outubro, o que já podia ter
            acontecido meses antes. As negociações com a Pfizer também atrasaram
            pelas recusas de Bolsonaro e, a essa altura, ainda estavam no
            início.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">20/Dezembro/2020</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Mais de 40 países já tinham iniciado a vacinação. A China, a essa
            altura, já tinha vacinado mais de 4,5 milhões de pessoas com os
            imunizantes produzidos no país e que foram recusados por Bolsonaro.
            No Brasil ninguém havia sido vacinado até então.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">17/Janeiro/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Quase um ano após o início da pandemia e depois de dezenas de
            milhões de vacinados no mundo, a primeira brasileira foi imunizada
            em São Paulo, sem apoio do Presidente e com forte disputa midiática
            por parte do governo federal que trabalhou até o último instante
            contra a produção brasileira de vacinação.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">21/Janeiro/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            O Ministério da Saúde dá um calote no Instituto Butantan e não
            repassa verba para produção da vacina. O valor de R$ 80 milhões foi
            previsto em convênio firmado dia 24 de dezembro de 2020 para
            desenvolvimento e compra de vacinas produzidas pelo Instituto, mas
            não foi pago. Enquanto isso, R$ 90 milhões foram gastos na compra de
            medicamentos ineficazes.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">22/Janeiro/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Chegam as primeiras doses da vacina de Oxford, produzida pela
            farmacêutica AstraZeneca, negociadas pela Fiocruz. A Fundação
            anunciou a negociação para aquisição de mais 15 milhões de doses.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">15/Fevereiro/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            6 meses depois, o Ministério da Saúde anuncia a compra de 100
            milhões de doses da vacina da Pfizer, que prometeu entregar 1 milhão
            de doses até abril. Além dela, foram adquiridas 38 milhões de doses
            da vacina Janssen, produzida pela Johnson & Johnson, que prometeu
            entregar metade até novembro de 2021.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">01/Março/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Com a opção de Bolsonaro por atrapalhar ou recusar as negociações
            por vacina, governadores de todo o Brasil se unem em movimento para
            compra dos imunizantes russos de forma autônoma.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">02/Março/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Quase 3 meses depois do lançamento do Plano Nacional de Imunização,
            Bolsonaro sancionou a lei que permite que o Brasil adquira vacinas
            do consórcio Covax Facility. A iniciativa prevê a aquisição de 42
            milhões de doses.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">05/Março/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Ministério da Saúde “esquece” de repassar 16 mil doses da vacina
            para indígenas. As vacinas ficaram abandonadas em um depósito no
            Pará.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">23/Março/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Marcelo Queiroga assume o Ministério da Saúde. O ministro defende a
            aquisição de vacinas pela iniciativa privada.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">25/Março/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Justiça libera compra de vacinas pelo setor privado sem a obrigação
            de repasse para o SUS. Com a decisão, pobres ficam ainda mais atrás
            na corrida pela imunização. No mesmo dia, a Direção da Covax
            Facility anuncia que a entrega de 1,9 milhões de vacinas para o
            Brasil, prevista para março, vai atrasar e só deve ocorrer em maio.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">06/Abril/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            4.195 brasileiros morreram de Covid-19 em 24h, ou seja, 1 pessoa
            morreu a cada 20 segundos e o país passou a ser recordista mundial
            de óbitos no período. Desde o início de março, o Brasil é o local
            mais perigoso do mundo para se estar durante a pandemia, pois é onde
            há mais mortes diárias causadas pelo vírus. Até a data, apenas 9,6%
            da população tomou a primeira dose da vacina e 2,6% tomou a segunda
            dose.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">07/Abril/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            TRF-1 derruba a liminar que autorizou a compra de vacinas por
            entidades privadas sem a obrigação de repasse para o SUS. Isso
            significa que a autorização está suspensa. Simultaneamente, o
            governo cortou a verba destinada para pesquisas, impedindo que o
            IBGE realize o Censo, que já estava sendo adiado desde 2020 em razão
            da pandemia. Acontece que o impacto de não produzir dados sobre a
            população brasileira impede a implementação eficaz de políticas
            públicas, entre as quais, a vacinação. Sem conhecer a população
            através da pesquisa, a vacinação pode ser ainda mais prejudicada. O
            Censo é importante instrumento para mapear as demandas regionais, a
            densidade populacional e as desigualdades sociais.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">08/Abril/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Câmara dos Deputados retira da pauta a discussão sobre o
            posicionamento brasileiro em relação à quebra de patentes das
            vacinas contra Covid-19 na Organização Mundial do Comércio e
            Organização Mundial de Saúde. Em outubro de 2020, Índia e África do
            Sul levaram a proposta à OMC e 99 países apoiaram. O único país
            pobre que se opôs à quebra de patentes foi o Brasil. O Governo
            Federal se opõe, até hoje, à quebra de patentes.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">09/Abril/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            O Ministério da Saúde suspende a divulgação do cronograma e a
            distribuição das vacinas no Brasil. A ação é mais uma que integra a
            falta de transparência e a descoordenação do Governo Bolsonaro na
            gestão da vacinação no país.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">27/Abril/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            É instaurada a CPI da Pandemia para investigar as ações e omissões
            do governo federal no enfrentamento à Covid-19 e repasses a estados.
          </div>
        </div>
        <div class="horizontal horizontal-1">
          <div class="titulo">30/Abril/2021</div>
          <div class="linha-pontinhada">
            <div class="ball"></div>
          </div>
          <div class="text">
            Mais de 400 mil vidas perdidas pela Covid-19 no Brasil.
          </div>
        </div>
      </div>
    </div>
    <div class="arraste-section" @click="scrollRight">
      Arraste para o lado <i class="bi bi-chevron-double-right seta"></i>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    scrollRight() {
      let content = document.querySelector(".nucleo11scroll1");
      content.scrollLeft += 300;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-red {
  margin-top: 60px;
  background-color: #d01c1f;
  color: white;
  font-family: Roboto Mono;
  padding: 2px 2px 0px 2px;
  font-size: 1.5rem;
  font-weight: 300;
}

.linha-pontinhada {
  border-bottom: 1px dashed #d01c1f;
  position: relative;
  margin-bottom: 20px;
  .ball {
    width: 12px;
    height: 12px;
    border-radius: 10px;
    background: #d01c1f;
    position: absolute;
    left: 0;
    bottom: -7px;
  }
}

.horizontal-content {
  color: #d01c1f;
  font-size: 1.1rem;
  font-family: Roboto Condensed;
  font-weight: 300;
  padding: 30px;
  display: flex;
  width: fit-content;
}

.seta {
  color: #626262;
  margin-right: 50px;
}

.complemento {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 300;
  font-size: 1rem;
  line-height: 1.1rem;
  position: relative;
  top: -50px;
}

.line {
  width: 1px;
  height: 540px;
  margin: 0 55px;

  &.none {
    background-color: transparent;
    margin: 0 30px 0 15px;
  }
}

.horizontal {
  position: relative;
  overflow-y: auto;
  width: 100%;

  .data {
    font-size: 3rem;
    font-family: Roboto Mono;
    font-weight: 100;
  }

  .titulo {
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: 300;
    font-size: 1.8rem;
    line-height: 1.7rem;
    color: #d01c1f;
    margin-bottom: 30px;
    width: 260px;
  }
  .text {
    width: 290px;
    font-family: Roboto Condensed;
    font-style: normal;
    font-weight: 300;
    font-size: 1rem;
    line-height: 1.1rem;
    text-align: justify;
    color: #000000;
    margin-bottom: 30px;
    max-height: 400px;

    padding: 0 60px 0 0;

    b {
      color: #000000;
      display: inline;
      font-weight: 500;
    }

    &.big {
      font-size: 3rem;
      line-height: 3.1rem;
      font-family: Roboto Mono;
      color: #626262;
      font-weight: 100;
    }
  }
  img {
    width: 260px;
  }
  .numeracao {
    font-family: Roboto Mono;
    font-weight: 100;
    font-size: 3.3rem;
  }
}

*::-webkit-scrollbar {
  width: 0px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
}

*::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}
</style>